module.exports = __webpack_public_path__ + "img/C00001.e0418e42.png";